<template>
  <div>
    <!-------------- 基本信息 -------------->
    <basic-information-supplier
      :basicInformation="basicInformation"
      :isEditSave="isEditSave"
      @onUpdateRules="onUpdateRules"
      ref="basicInformationSupplierRef"
    ></basic-information-supplier>
    <!-------------- 活动设置 -------------->
    <activity-set
      :supplierActivitycontentList="supplierActivitycontentList"
      :basicInformation="basicInformation"
      @onRulesActivitySet="onRulesActivitySet"
      :isEditSave="isEditSave"
      ref="activitySetRef"
    ></activity-set>
    <div style="margin:20px 0;">
      <el-button
        type="primary"
        v-show="!isEditSave&&basicInformation.acState!==3"
        @click="onEditSave(2)"
      >修改</el-button>
      <el-button type="primary" v-show="isEditSave&&basicInformation.acState!==3" @click="onEditSave(1)">保存</el-button>
      <!-- <el-button v-show="isEditSave&&basicInformation.acState!==3" @click="onEditSave(3)">取消</el-button> -->
      <el-button
        @click="onDeleteActivity(basicInformation)"
        v-if="!isEditSave&&basicInformation.acState===1"
      >删除</el-button>
      <el-button type="primary" v-show="basicInformation.acState===3&&!($route.query.acceptanceSate)" @click='collection'>申请收款</el-button>
      <el-button @click="endActivity(basicInformation)" v-show="!isEditSave &&basicInformation.acState===2">结束活动</el-button>
    </div>
    <!-------------- 操作日志 -------------->
    <load-operation-log :id="this.$route.query.id"></load-operation-log>
    <!-------------- 删除活动和结束活动 -------------->
    <again-hint ref="againHintRefs" @goToUpdata="onDelOrEnd" :content="content" :title="title"></again-hint>
  </div>
</template>
<script>
import basicInformationSupplier from '../components/supplier/basicInformationSupplier'
import activitySet from '../components/supplier/activitySet'
import loadOperationLog from '@/components/OperationLog/loadOperationLog'
import againHint from '@/components/AgainHint/index'
import {
  supplierActivityQueryById,
  supplierActivityUpdate
} from '@/api/supplier/supplierManage'
export default {
  components: {
    'basic-information-supplier': basicInformationSupplier,
    'load-operation-log': loadOperationLog,
    'activity-set': activitySet,
    'again-hint': againHint
  },
  data () {
    return {
      basicInformation: {},
      supplierActivitycontentList: [],
      isEditSave: false,
      title: '', // 删除活动标题,结束活动标题
      content: '', // 删除活动标题,结束活动标题
      type: -1,
      countParams: true
    }
  },
  mounted () {
    this.getEditById()
  },
  methods: {
    // 获取详情数据
    getEditById () {
      supplierActivityQueryById(this.$route.query.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.basicInformation = res.data.obj
            this.supplierActivitycontentList =
              res.data.obj.supplierActivitycontentList
            this.supplierActivitycontentList.forEach(element => {
              element.preamount = element.preamount * 100
              element.proRebate = element.proRebate * 100
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 结束活动
    endActivity (row) {
      this.title = '结束活动'
      this.content = '确定结束该活动？'
      this.$refs.againHintRefs.onInitial(row)
    },
    // 删除活动
    onDeleteActivity (row) {
      this.title = '删除活动'
      this.content = '确定删除该活动？'
      this.$refs.againHintRefs.onInitial(row)
    },
    // 再次确认删除还是结束活动
    async onDelOrEnd (params) {
      if (this.title === '删除活动') {
        // 删除活动
        await this.$deleteActivity(params)
        this.$router.push('/crm/supplier/activityList')
      } else {
        // 结束活动
        await this.$endActivity(params)
        this.$router.push('/crm/supplier/activityList')
      }
    },
    // 保存前校验
    onEditSave (val) {
      this.type = val
      if (val === 1) {
        this.countParams = true
        this.$refs.basicInformationSupplierRef.onRulesBase()
        this.$refs.activitySetRef.onRulesActivitySet(val)
      }
      if (val === 2) {
        this.countParams = true
        this.isEditSave = true
        this.$refs.basicInformationSupplierRef.onRulesBase()
        this.$refs.activitySetRef.onRulesActivitySet(val)
      } else if (val === 3) {
        this.isEditSave = false
      }
    },
    // 判断校验是否通过
    onUpdateRules (isBool) {
      if (isBool) {
        this.state = true
      } else {
        this.$message.error('验证未通过,请检查后再提交!')
      }
    },
    onRulesActivitySet (isBool) {
      if (isBool && this.state === true) {
        this.onSaveUpdateInfo(this.type)
      } else if (this.countParams) {
        this.$message.error('验证未通过,请检查后再提交!')
        this.countParams = false
      }
    },
    // 申请收款跳转
    collection () {
      this.$router.push({
        path: '/crm/supplier/initiatCollection',
        query: { id: this.$route.query.id, name: this.$route.query.name }
      })
    },
    // 保存修改后的活动信息
    onSaveUpdateInfo (type) {
      if (type === 1) {
        const setList = []
        this.$refs.activitySetRef.queryParams.forEach((item) => {
          const paramsSet = {

            brId: item.brandParams.id,
            brSid: item.seriesParams.id,
            brandCoefficient: item.brandParams.brandCoefficient,
            flag: true,
            preamount: item.preamount,
            proCoefficient: item.proModelParams.proCoefficient,
            proModel: item.proModelParams.proModel,
            proRebate: item.proRebate,
            seriesCoefficient: item.seriesParams.seriesCoefficient,
            tarPrice: item.tarPrice,
            id: item.id
          }
          setList.push(paramsSet)
        })
        setList.forEach((element) => {
          element.preamount = element.preamount * 0.01
          element.proRebate = element.proRebate * 0.01
        })
        const params = {
          acState: +this.$route.query.acState,
          supplierActivity: {
            acEnd: this.$refs.basicInformationSupplierRef.queryParams.time[1],
            acStar: this.$refs.basicInformationSupplierRef.queryParams.time[0],
            acTitle: this.$refs.basicInformationSupplierRef.queryParams.acTitle,
            flag: true,
            suId: this.$refs.basicInformationSupplierRef.queryParams.suId,
            id: this.$route.query.id
          },
          supplierActivityContentVoList: setList
        }
        supplierActivityUpdate(params)
          .then((res) => {
            if (res.data.code === 200) {
              this.isEditSave = false
              this.$message.success('修改成功!')
              this.$router.push('/crm/supplier/activityList')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.isEditSave = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
